import { render, staticRenderFns } from "./SectionBenefits.vue?vue&type=template&id=ea2afa52&"
import script from "./SectionBenefits.vue?vue&type=script&lang=js&"
export * from "./SectionBenefits.vue?vue&type=script&lang=js&"
import style0 from "./SectionBenefits.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports